import { ref } from 'vue'

// Module-level singleton so AppHeader and NavigationDrawer share state
const isDrawerOpen = ref<boolean | null>(null)

export function useNavigationDrawer() {
  const toggle = () => {
    isDrawerOpen.value = !isDrawerOpen.value
  }

  const open = () => {
    isDrawerOpen.value = true
  }

  const close = () => {
    isDrawerOpen.value = false
  }

  return { isDrawerOpen, toggle, open, close }
}
